import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import ShowModal from '../../components/showModal/index.jsx';
import DialogAddShopSteps from '../../components/dialogAddShopSteps/index.jsx';
import DialogShowPlatforms from '../../components/dialogShowPlatforms/index.jsx';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import './myAuth.less';
import { Icon, Button, Steps, Tag, Message, Dialog, Alert,MessageBox,Table } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import {requests, loadZhuKeToken,getLoginShopName,getToken, messageShow,getPlatformName,systemConfig,getLoginShopInfo,funSplitType,isLoadSystem,loadSysTem } from '../../utils/http';
import { GetBuyerShopUserInfoRequest,TaoteGenerateQRCodeRequest,TaoteAuthRequest,GetAuthTaskRequest, getZhuKeReqTask,UnBindBuyerShopRequest,AddSiteLogByShopRequest,AddSiteLogRequest} from '../../utils/api';
import $ from 'jquery'
import QRCode from 'qrcode.react';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import { otherExposureReport } from '../../utils/alibabareport.js';

class distributionLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alibabaPageKey:'authorize',
      shops: [{ value: '1', label: '店铺01' }, { value: '2', label: '店铺02' }],
      alibabaZhukeShopId:'',//阿里巴巴主客shopid
      alibabaShopName: '',
      loginShopName: '',//当前登录的店铺名称
      bingBuerShopStuts: 0,//是否绑定了1688的主客店铺，0是初始化前的，1是有绑定，2是没绑定1688
      endDay: 0,
      paySkuVersion: '',
      paySkuName: '',
      authorizationDialogVisible: false,
      loading:false,
      loginToken:'',

      //阿里授权相关
      alibabaAuth:true,//阿里是否授权

      /**淘特相关授权 */
      taoteAuthInfo:{
        status:0,
        nickName:'',
        shopId:'',

        qrcodeShow:false,
        authUrl:'',//
        authCode:'',//授权code
        authTimeSpan:0,
        refreshQRCode:false,
      },
      bindShopList:[],
      shopTableColumn : [
        { 
          label: "分销平台",
          width: 160,
          render:(item)=>{ return <span>{ getPlatformName(item.PlatformType)}</span> }
        },
        {
          label: "店铺名称",
          prop: "ShopName",
          width: 220
        },
        {
          label: "服务到期时间",
          prop: "ServiceEndTime",
          width: 200
        },
        {
          label: "授权状态",
          width: 120,
          render:(item)=>{
            return <div>{
              item.PayUrl != "" ? <Tag type='danger'>授权已失效</Tag>:  
              item.PayUrl == "" && item.AuthUrl != "" ? <Tag type='danger'>授权已失效</Tag>:
              <Tag type='success'>正常</Tag>}</div>
          }
        },
        {
          label: "操作",
          width: 280,
          align:"center",
          render: (item)=>{ return this.shopListOperateRender(item,this)}
        }
      ],
      from_action:'',//其他页面跳转授权页，taote_auth_expire, alibaba_auth_expire
      unBindBuyerShopStatus:'',//解绑买家店铺状态
      unBindBuyerShopDoingDialog:false,//进行中解绑账号dialog


      /**添加店铺相关 */
      isShowAddShop:false,
      selectPlatform: 'TouTiao',
      selectPlatformName:'头条',
      isShowChoosePlatform:false,//选择平台
      isShowUnBind:false,//
      unBingShopId:'',//
      unBingShopName:'',

      funSplitTypes: funSplitType(),
    };
  }
  componentDidMount() {
    try{
      setTimeout(()=>{ 
        var shopJson = localStorage.getItem('home_shop_list');
        var hasZhukeLoginShopTokens = localStorage.getItem('hasZhukeLoginShopTokens');
        var shops = JSON.parse(shopJson);
        if(shops)
        {
          this.state.bindShopList = shops ||[];
          this.setState({ });
        }
      },3000);

      //不同版本（双应用情况下），显示页面不同
      if(isLoadSystem()==false)
      {
        $(".myAuth").removeClass("is-active");
        if(this.state.funSplitTypes==2){
          $(".orderList").addClass("is-active");
          this.props.history.push('/orderList');
        }else{
          $(".index").addClass("is-active");
          this.props.history.push('/index');
        }
        loadSysTem();
      }
      otherExposureReport(this.state.alibabaPageKey);
      
     
      
    }catch(e){
      console.log(e)
    }

    //其他页面授权失效跳转,授权页
    if(this.props.location.state && this.props.location.state.from_action)
    {
      var action =this.props.location.state.from_action;
      this.state.from_action = action;
    }
    var loginShopName = getLoginShopName();
    if (loginShopName == null || loginShopName == undefined || loginShopName == "") {
      var that = this;
      setTimeout(() => {
        that.loadShopName();
      }, 1500);
    } else
      this.loadShopName();
  }

  loadShopName = () => {
    var loginShopName = getLoginShopName();

    this.setState({loginShopName:loginShopName});

    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
    this.state.loginToken = hasZhukeLoginShopTokens;

    var zhukeToken = getToken();
    var that = this;
    if (zhukeToken != "")
    {
      that.getBuyerShopUserInfoByTaote();
      that.getBuyerShopByUserInfo();
    }
    else {

      setTimeout(() => {
        var zhukeTokenTwo = getToken();
        if (zhukeTokenTwo == "") {
          //var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试
          if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree = getToken();
              if (zhukeTokenThree != "")
              {
                that.getBuyerShopUserInfoByTaote();
                that.getBuyerShopByUserInfo();
              }
              else
              {
                that.state.taoteAuthInfo.status= 2;
                that.setState({bingBuerShopStuts: 2});
              }
            }, 500);
          }else
          {
            that.state.taoteAuthInfo.status= 2;
            that.setState({bingBuerShopStuts: 2});
          }
        } else
        {
          that.getBuyerShopUserInfoByTaote();
          that.getBuyerShopByUserInfo();
        }
      }, 800);

    }

  }

  //获取1688的订购情况
  getBuyerShopByUserInfo = () => {

    var data = {
      SystemVersions: 'pc'
    };
    var that = this;
    requests({
      url: "/Common/GetIndexByUserInfo",
      data: data,
      success: (json) => {
        if (json.Success) {
          var result = json.Data;
          systemConfig.zhukeAlibabaAuth = result.Expired;
          that.setState({
            bingBuerShopStuts: 1,   //要改成1
            endDay:parseInt(result.EndDay),
            //endDay: 5,
            paySkuVersion: result.SkuVersion,
            //paySkuVersion:'V2',
            paySkuName: result.SkuName,
            alibabaShopName:result.LoginName,
            loading:false,
            alibabaAuth:result.Expired,
          });
        } else
          that.setState({ bingBuerShopStuts: 2 });
      },
      fail: (err) => {
        that.setState({ bingBuerShopStuts: 2 });
      }
    })
  }

  /**获取淘特绑定相关 */
  getBuyerShopUserInfoByTaote()
  {
      GetBuyerShopUserInfoRequest().then(res =>{
        if(res.Success){
          var taoteBuyer = res.Data && res.Data.find(s => s.SourcePlatform == "TaoteZhuKe");
          var alibabaBuyer = res.Data && res.Data.find(s => s.SourcePlatform == "AlibabaZhuKe");
          if(taoteBuyer)
          {
            var taoteInfo = taoteBuyer;
            this.state.taoteAuthInfo.nickName = taoteInfo.LoginName;
            this.state.taoteAuthInfo.shopId = taoteInfo.ShopId;
            this.state.taoteAuthInfo.status = 1;
          }
          else{
            this.state.taoteAuthInfo.status = 2;
          }
          if(alibabaBuyer)
          {
            this.state.alibabaZhukeShopId = alibabaBuyer.ShopId;
          }
          this.setState({});
        }else{
          messageShow('获取淘特授权信息：'+res.Message,'error');
        }
      })
  }
  
  changeSelect = (value, name) => {
    //console.log(value)
  }
  
  //新订购
  newPayPuHuo = () => {
    var urls = "https://mfuwu.1688.com/offer/promoterOffer.htm?apid=6q1pROB0Q8U6%2B%2B4znWxsI4pGADXqtNn380DqRsaf30TVLYfqB9IrpMr7%2BDhrbLyHKK3%2FV1n8BqQwo3u6HqJ7%2BzsP";
    window.open(urls);
  }


   //升级
   upgradePuHuo = () => {
    var urls = "https://pc.1688.com/product/detail.htm?productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404";
    window.open(urls);

    MessageBox.confirm('您是否已经完成了升级？', '提示', {
      type: 'warning',
      confirmButtonText:"完成升级"
    }).then(() => {
      this.authComplete();
    }).catch(() => {
      this.authComplete();
    });
  }

  //续费
  xufeiPuHuo = () => {
    var urls = "https://pc.1688.com/product/detail.htm?productCode=9jfqg47cgv%2BOQ6fUAivdsD8rdHg3GaQdLZXRMHuKiVM%3D&productType=GROUP";
    window.open(urls);


    MessageBox.confirm('您是否已经完成了续费？', '提示', {
      type: 'warning',
      confirmButtonText:"完成续费"
    }).then(() => {
      this.authComplete();
    }).catch(() => {
      this.authComplete();
    });
  }



  


  authPuhuo = () => {


    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
    var succToUrl = "https://alizk.dgjapp.com/%23%2F?token=" + hasZhukeLoginShopTokens;
    //var succToUrl = systemConfig.serverLink() + '?token=' + hasZhukeLoginShopTokens
    var urls = "https://zk.dgjapp.com/auth/AlibabaByCommByAlone?SuccToUrl=" + succToUrl + "&rp=" + hasZhukeLoginShopTokens;

    if(this.state.funSplitTypes ==2)//双应用的第二个应用
       urls = "https://zk.dgjapp.com/auth/AlibabaByCommByAloneByOrder?SuccToUrl=" + succToUrl + "&rp=" + hasZhukeLoginShopTokens;
    
    window.open(urls);
    
    this.setState({
      authorizationDialogVisible:false,
      upgradeDailog:false,
    })
    MessageBox.confirm('您是否已经完成了授权？', '提示', {
      type: 'warning',
      confirmButtonText:"完成授权"
    }).then(() => {
      //console.log("完成授权")
      this.authComplete();
    }).catch(() => {
      //console.log("取消")
      this.authComplete();
    });

  }
  authorizationDialog = (addlog) => {
    if(addlog){
      this.addLog('授权页-点击登录1688','my_auth_click_alibaba_auth')
    }
    this.setState({
      authorizationDialogVisible: true
    })
  }
  addLog(remark,type){
    const loginToken = localStorage.getItem("hasZhukeLoginShopTokens") || null;
    const platformType = getLoginShopInfo().loginShopPlatformType;
    const loginShopId = getLoginShopInfo().loginShopId;
    const zkToken = getToken();
    const data ={
        SiteType : 'pc',
        OperatorType: type,
        Remark: remark,
        PlatformType:platformType,
        ShopId:loginShopId,
        token:loginToken,
    };
    if(zkToken){
        AddSiteLogRequest(data);
    }else{
        AddSiteLogByShopRequest(data)
    }
  }
  showUpgradeDailog(is_xufei){
    this.setState({ upgradeDailog : true,is_xufei:is_xufei});
  }

  authComplete=()=>{
    this.setState({loading:true});
    var that=this;
    var zhukeToken = getToken();
    if (zhukeToken == "") {
      var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
      if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
        loadZhuKeToken(hasZhukeLoginShopTokens);

        setTimeout(() => {
          var zhukeTokenTwo = getToken();
          if (zhukeTokenTwo != "")
          {
            that.getBuyerShopUserInfoByTaote();
            that.getBuyerShopByUserInfo();
            if(that.NewUserGuide){
              that.NewUserGuide.loadQuickGuideData()
            }
          }
          else 
          {
            Message({message: "未查询到绑定1688买家账号"});
            that.setState({bingBuerShopStuts: 2,loading:false});
          }
          
        }, 500);
      }
    } else
    {
     
      setTimeout(() => {
        that.getBuyerShopUserInfoByTaote();
        that.getBuyerShopByUserInfo();
      }, 1000);
    }
  }
  /**淘特二维码生成 */
  taoteGenerateQRCode(){
    if(!this.state.loginToken)
    {
      messageShow('您当前未登录，请到店铺后他选择服务点击去使用','error');
      return;
    }
    const data = {
      token:this.state.loginToken
    }
    this.state.taoteAuthInfo.refreshQRCode =true;
    this.setState({})
    setTimeout(() =>{
      TaoteGenerateQRCodeRequest(data).then(res =>{
        this.state.taoteAuthInfo.refreshQRCode =false;
        this.setState({})
        if(res.Success)
        {
          var result = res.Data;
           this.state.taoteAuthInfo.refreshQRCode =false;
  
          this.state.taoteAuthInfo.authUrl = result.Item2;
          this.state.taoteAuthInfo.authCode = result.Item1;
          this.state.taoteAuthInfo.authTimeSpan = 120;
          this.setState({},()=>{
            var authTimeSpan = 118;
            authTimeSpan = Math.floor(authTimeSpan);
            
            this.setAuthCodeInterval(authTimeSpan);
            setTimeout(()=>{
              this.taotePollAuth();
            },3000)
            
          })
        }else{
          messageShow(res.Message,'error');
        }
      })
    },100)
    
  }
  taoteGenerateQRCodeClick(addlog){
    this.state.taoteAuthInfo.qrcodeShow = true;

    if(addlog){
      this.addLog('授权页-点击授权淘特','my_auth_click_taote_auth');
    }
    this.setState({},()=>{
      this.taoteGenerateQRCode()
    });
  }
  setFieldData(dto,name,value){
    dto[name] = value
    this.setState({})
  }
  setAuthCodeInterval(timespan)
  {
    $("#authTimespan").text(timespan);
    this.state.taoteAuthInfo.authTimeSpan = timespan
    if(timespan == 0 || !this.state.taoteAuthInfo.authUrl){
      this.clearTaoteQrInfo();
      return;
    }

    var that =this;
    timespan = timespan - 1;
    setTimeout(()=>{
      that.setAuthCodeInterval(timespan);
    },1000)
  }
  taotePollAuth(){
    if(this.state.taoteAuthInfo.authTimeSpan < 2 || !this.state.taoteAuthInfo.authUrl)
    {
      this.clearTaoteQrInfo();
      return;
    }

    const data ={
      tempCode:this.state.taoteAuthInfo.authCode,
      token:this.state.loginToken
    }
    var that = this;
    TaoteAuthRequest(data).then(res =>{
      if(res.Success)
      {
        var taskCode = res.Data;
        that.state.taoteAuthInfo.qrcodeShow =false;
        that.clearTaoteQrInfo();
        that.setState({loading:true},()=>{
          that.taoteAuthSuccess(taskCode,0);
        })
      }else
      {
        if(res.ErrorCode == 'USER_NOT_CANE_QRCODE'){
          setTimeout(()=>{
            that.taotePollAuth();
          },1500)
        }else{
          that.state.taoteAuthInfo.qrcodeShow =false;
          that.setState({})
          that.clearTaoteQrInfo();
          messageShow('授权信息获取失败','error')
        }
      }
    })
  }
  taoteAuthSuccess(taskCode,num){
    if(num > 20)
      return;
    num++;
    const data ={ TaskCode :taskCode };
    GetAuthTaskRequest(data).then(res =>{
      if (res.Success) {
        var task = res.Data;
        if (task.FinishedTime != null && task.FinishedTime != "" && task.FinishedTime != undefined) {
            this.setState({ loading: false });
            if (task.Status == "Error" && task.ErrorMsg != null && task.ErrorMsg != undefined && task.ErrorMsg != "") 
            {
              messageShow('授权失败：'+ task.ErrorMsg,'error')
            }else{
              messageShow('授权成功')
              // this.getBuyerShopUserInfoByTaote();
              setTimeout(() => {
                window.history.go(0);
              }, 800);
            }
        } else {
            setTimeout(() => {
                this.taoteAuthSuccess(taskCode,num);
            }, 1000);
        }
      }
      else
      {
        setTimeout(() => {this.taoteAuthSuccess(taskCode,num)}, 1000);
      }
    })
  }
  /**清除二维码 */
  clearTaoteQrInfo(){
    this.state.taoteAuthInfo.authUrl = "";
    this.state.taoteAuthInfo.authCode = "";
    this.state.taoteAuthInfo.authTimeSpan = 0;
    this.state.taoteAuthInfo.refreshQRCode =false;
    this.setState({});
  }
  //重新授权
  reAuthTaote(){
    MessageBox.confirm("确定要重新授权吗？点击重新绑定务必重新扫码授权，否则授权信息将失效","提示")
    .then(()=>{
      this.taoteGenerateQRCodeClick();
    })
    .catch(()=>{

    })
    
  }
  unBindBuyerShop(item){
    if(this.state.unBindBuyerShopStatus)
      MessageBox.alert('当前正在解绑买家账号中');
    
    MessageBox.confirm(
      <div className='unBindBuyerShop-confirm-dialog'>
        <div className='unBindBuyerShop-confirm-dialog-text'>请确认是否解绑货源账号</div>
        <div className='unBindBuyerShop-confirm-dialog-info'>解绑货源采购账号会清除当前货源采购账号的所有数据，包括铺货日志记录、代销商品数据(店铺订单与货源的关联关系)、采购订单数据(未发货的订单需要手动回传单号)、相关订单设置及售后设置也会关闭</div>
      </div>,"确认是否解绑货源账号")
    .then(()=>{
      this.unBindBuyerShopConfirm(item);
    }).catch(()=>{ })
  }
  unBindBuyerShopConfirm(item){
    
    const data = { BuyerShopId:item.buyerShopId }
    MessageBox.confirm('解绑货源采购账号会清除当前货源采购账号的所有数据,确认是否解绑?','确认是否解绑').then(()=>{
      
      UnBindBuyerShopRequest(data).then(res =>{
        if(item.PlatformType == "TaoteZhuKe")
          this.setState({ unBindBuyerShopStatus:"2"})
        else if(item.PlatformType == "AlibabaZhuKe")
          this.setState({ unBindBuyerShopStatus:"1"})
        if(res.Success){
          const taskCode = res.Data;
          setTimeout(()=>{ this.unBindBuyerShopTaskPoll(item,taskCode,0); },8000)
          this.state.unBindBuyerShopDoingDialog = true;
          this.setState({})
        }else{
          this.messageShow(res.Message,'error');
        }
      })
    })
  }
  unBindBuyerShopTaskPoll(item,taskCode,num){
    if(num > 15) return
    num++;
    GetAuthTaskRequest({TaskCode:taskCode}).then(res =>{
      if (res.Success) {
        var task = res.Data;
        if (task.FinishedTime != null && task.FinishedTime != "" && task.FinishedTime != undefined) {
            this.state.unBindBuyerShopDoingDialog = false
            this.setState({ });
            
            if (task.Status == "Error" && task.ErrorMsg != null && task.ErrorMsg != undefined && task.ErrorMsg != "") 
            {
              messageShow('解绑失败: '+ task.ErrorMsg,'error')
            }else{
              messageShow('解绑成功')
              setTimeout(() => { window.history.go(0); }, 1000);
            }
        } else {
            setTimeout(() => { this.unBindBuyerShopTaskPoll(item,taskCode,num); }, 2000);
        }
      }
      else
      {
        setTimeout(() => {this.unBindBuyerShopTaskPoll(item,taskCode,num)}, 2000);
      }
    })
  }
  shopListOperateRender(item,that){
    var ele = 
    <div style={{"display":"flex","justifyContent":"end","gap":"10px"}}>
      {
          item.PayUrl!="" && item.AuthUrl==""?<span className='link_click_text' onClick={()=>{ that.shopAuthClick(item) }}>订购授权</span>:""
      }
      {
          item.AuthUrl!="" && item.PayUrl==""?<span className='link_click_text' onClick={()=>{ that.shopAuthClick(item) }}>重新授权</span>:""
      }
      {
          item.AuthUrl!="" && item.PayUrl!=""?<span className='link_click_text' onClick={()=>{ that.shopAuthClick(item) }}>订购授权</span>:""
      }
      <span className='link_click_text' onClick={()=>{ that.confirmUnBing(item.Id,item.ShopName)}}>解绑店铺</span>
    </div>;
    return ele;
  }
  shopAuthClick(item){
    const platformName = getPlatformName(item.PlatformType);
    this.state.isShowAddShop = true;
    this.state.selectPlatform = item.PlatformType;
    this.state.selectPlatformName = platformName;
    this.setState({});
  }
  //由子组件传回
  changeShops = (platforms, selectPlatform) => {
    const platformName = getPlatformName(selectPlatform);
    this.state.selectPlatformName = platformName;
    this.setState({
        platforms: platforms,
        selectPlatform: selectPlatform
    });
  }
                  
  closeAddShopModal = () => {
    this.setState({
        isShowAddShop: false
    })
  }

  //返回软件内确认授权结果
  sureAuthShop = () => {
    let that = this;
    setTimeout(function () {
        that.setState({
            isShowAuthShop: true
        })
    }, 3000)
  }
  successAuthShop = () => {
    var that = this;
    that.setState({
        loading: true,//关闭加载
        isShowAuthShop: false,//关闭授权弹窗
        hasLoadBorder: true
    });
    requests({
        url: "/MyShop/AuthNewShop",
        data: {},
        success: function (res) {
            that.setState({ loading: false, hasLoadBorder: false }); //关闭动画
            if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                return;

            if (res.Success) {
                var shopid = res.Data.ShopId;
                if (shopid != 0 && shopid != "") {
                    messageShow('授权成功', "success", 3000);
                    setTimeout(() => { window.history.go(0);}, 1500);
                }
                else
                    messageShow('未授权成功', "info");
            } else
                messageShow(res.Message, "error");
        },
    });
  }
  cancelModul = (typeName) => {
    this.setState({
        [typeName]: false
    })
  }
  //添加弹框
  addShop = () => {
    var userFreeAndExceedLimit = $("#userFreeAndExceedLimit").html();
    if (userFreeAndExceedLimit == "true")
        this.setState({ isShowAddShopByUpgradeApp: true });
    else {
        this.setState({
            isShowChoosePlatform: true,
            selectPlatform: 'TouTiao',
            loading: false,
        })
    }
  };
  //选择平台确定的弹窗确认按钮
  sureChoosePlatform = () => {
    // console.log("selectPlatform", this.state.selectPlatform)
    this.setState({
        isShowChoosePlatform: false,
        isShowAddShop: true
    })
  }
  //开始移除店铺
  startUnBing=()=>{
    var idList = [];
     idList.push(this.state.unBingShopId);
     var data = {
       ShopIds: idList
     };

     var that=this;
     that.setState({  
         loading:true,
         isShowUnBind:false,//关闭授权弹窗
         hasLoadBorder:true,
         loadingTitle:'解绑中...',
     });
     var sureUnBindShopPost = { taskCode: "",errRes: "" };

     requests({
         url: "/MyShop/UnBindShop",
         data: data,
         success: function (res) {
             if(res.RequestError == true)//请求失效了。isLoading关闭看需求写
             {
                 that.setState({loading:false,hasLoadBorder:false,loadingTitle:'加载中...'}); //关闭动画
                 return;
             }

             if(res.Success){
                 sureUnBindShopPost.taskCode = res.Data;
                 that.setState({ sureUnBindShopPost: sureUnBindShopPost });

                 setTimeout(() => {
                     that.examineUnBindShopTask();
                 }, 1000);
             }else
                 messageShow("解除店铺错误："+ res.Message,'error');
         },
     });
  }

  examineUnBindShopTask=()=>{

    var sureUnBindShopPost=this.state.sureUnBindShopPost;

    var that=this;
    requests({
        url: "/Common/GetZhuKeReqTask",
        data: {TaskCode: sureUnBindShopPost.taskCode},
        success: function (res) {
            if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            {
              that.setState({loading:false,hasLoadBorder:false });
              return;
            }
    
            if (res.Success) {
              var dates = res.Data;

              if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
                that.setState({ loading: false, sureUnBindShopPost: { taskCode: "",errRes: ""} });
    
                if (dates.Status == "Error" && dates.ErrorMsg != null && dates.ErrorMsg != undefined && dates.ErrorMsg != "")
                    messageShow("解除失败:" + dates.ErrorMsg, 'error');
                else if (dates.Status == "Error" && dates.RspContent == null) 
                    messageShow("解除店铺失败，原因:RspConten is null", 'error');
                else {
                    messageShow("解除成功，并刷新页面。", 'success');
               
                  setTimeout(() => {
                    //that.loadList();//获取店铺列表
                    window.history.go(0);
                  }, 1000);
                }
              }else {
                //任务未执行完，继续轮训
                setTimeout(() => {
                  that.examineUnBindShopTask();
                }, 1000);
              }

            } else {
               messageShow("错误信息：" + res.Message,'error');
               that.setState({ loading:false,hasLoadBorder:false, sureUnBindShopPost: { taskCode: "",errRes: "" } });
            }
        },
    });
  }
  confirmUnBing=(shopId,shopName)=>{
    this.setState({
       isShowUnBind:true,
       unBingShopId:shopId,
       unBingShopName:shopName
    })
}
  showContact(){
    window.open('https://wpa1.qq.com/bjoIIG3j?_type=wpa&amp;qidian=true','_blank')
  }

  render() {

    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu defaultActive={"/myAuth"} />
          </div>
          <div className="wrap-right">

           {/* 从之前的项目拷贝过来的 */}
            <div className='mywrap'>
              <div className='mywrap-title'>货源授权情况</div>
              <div className='sourceplatform'>
                {
                  !this.state.from_action || this.state.from_action == "alibaba_auth_expire"?
                  <div className='sourceplatform-item'>
                    <div className='main-up sourceplatform-item-title'>1688分销货源授权绑定情况</div>
                    <div className='main-up'>
                      <span className='main-up-title'>当前登录的店铺名称：</span>
                      <span className='shopName'>{this.state.loginShopName}</span>
                    </div>
                    {
                      this.state.bingBuerShopStuts == 1 ?
                        <div>
                          <div className='main-up'>
                            <span className='main-up-title'>1688买家账号：</span>
                            <span>{this.state.alibabaShopName}</span>
                            {
                              !this.state.unBindBuyerShopStatus && false ? 
                                <span className='unBindBuyerShop-text' 
                                onClick={()=>{ this.unBindBuyerShop({ buyerShopId:this.state.alibabaZhukeShopId,PlatformType:'AlibabaZhuKe' })}}>解绑货源账号</span>:null
                            }
                            {
                              this.state.unBindBuyerShopStatus == '1' ? <span  className='unBindBuyerShop-doing-text'>账号解绑中...,请勿进行其他操作</span>:null
                            }
                          </div>
                          <div className='main-up'>
                            <span className='main-up-title'>1688授权状态：</span>
                            {
                              this.state.alibabaAuth === false ? <Tag type="danger">授权失效</Tag>:<Tag type="success">已授权</Tag>
                            }
                            {
                              this.state.alibabaAuth === false  ?
                                <Button type="primary" size="small" style={{"marginLeft":"10px"}} onClick={() => { this.authPuhuo()}}>重新授权</Button> : null
                            }
                          </div>

                          <div className='main-up'>
                            <span className='main-up-title'>买家账号版本：</span>
    
                            <div className='main-up-content'>
                              <div>
                                {/* <span>剩余{
                                  this.state.endDay > 3 && this.state.endDay < 8 ?
                                    <span style={{ color: "#F7941F", padding: "0 5px", fontSize: "16px" }}>{this.state.endDay}</span>
                                    : this.state.endDay >= 0 && this.state.endDay < 3 ?
                                      <span style={{ color: "#FF511C", padding: "0 5px", fontSize: "16px" }}>{this.state.endDay}</span>
                                      : <span>{this.state.endDay}</span>
                                }
                                  天</span>
                                <span>
                                  （{
                                    this.state.paySkuVersion == "V1" || this.state.paySkuVersion == "V0" ?
                                      <span className='tarVersion' style={{ backgroundColor: "#3aadff", color: "#fff" }}>{this.state.paySkuVersion}{this.state.paySkuName}</span>
                                      : this.state.paySkuVersion == "V2" ?
                                        <span className='tarVersion' style={{ backgroundColor: "#f7941f", color: "#fff" }}>{this.state.paySkuVersion}{this.state.paySkuName}</span>
                                        : <span className='tarVersion' style={{ backgroundColor: "#ff6600", color: "#fff" }}>{this.state.paySkuVersion}{this.state.paySkuName}</span>
                                  }）</span> */}

                                <span>
                                  {
                                    this.state.paySkuVersion == "V1" || this.state.paySkuVersion == "V0" ?
                                    <span className='tarVersion' style={{ backgroundColor: "#3aadff", color: "#fff" }}>{this.state.paySkuName}</span>
                                    : this.state.paySkuVersion == "V2" ?
                                      <span className='tarVersion' style={{ backgroundColor: "#f7941f", color: "#fff" }}>{this.state.paySkuName}</span>
                                      : <span className='tarVersion' style={{ backgroundColor: "#ff6600", color: "#fff" }}>{this.state.paySkuName}</span>
                                  }
                                  <span>（剩余{
                                  this.state.endDay > 3 && this.state.endDay < 8 ?
                                    <span style={{ color: "#F7941F", padding: "0 5px", fontSize: "16px" }}>{this.state.endDay}</span>
                                    : this.state.endDay >= 0 && this.state.endDay < 3 ?
                                      <span style={{ color: "#FF511C", padding: "0 5px", fontSize: "16px" }}>{this.state.endDay}</span>
                                      : <span>{this.state.endDay}</span>
                                  }
                                  天） </span>
                                </span>
        
                                {
                                  this.state.paySkuVersion =="V0" ||  this.state.paySkuVersion =="V1" ? 
                                  <Button type="primary" size="small" onClick={() => this.showUpgradeDailog(false)}>续订/升级</Button>
                                  :<Button type="primary" size="small" onClick={() => this.showUpgradeDailog(true)}>续订/升级</Button>
                                }
                                
                              </div>
                              {/* {
                              this.state.paySkuVersion =="V0" ||  this.state.paySkuVersion =="V1" ? 
                              <span style={{ color: "#FF511C", marginTop: "5px" }}>1688平台限制，免费版最多只能5次铺货，高级版不限铺货次数</span>:<span style={{marginTop: "5px" }}></span>
                              } */}
                            
                            </div>
                          </div>
                            {/* <div className='main-up'>
                             { 
                           //     this.state.paySkuVersion =="V0" ||  this.state.paySkuVersion =="V1" ? 
                           //       <Tag type="danger" style={{marginTop: "5px" }} size='large'>您订购的版本为免费版只能铺货5次，高级版不限铺货次教</Tag>:null
                                // <span style={{ color: "#FF511C", marginTop: "5px" }}>1688平台限制，免费版最多只能5次铺货，高级版不限铺货次数</span>:<span style={{marginTop: "5px" }}></span>
                              }
                            </div>*/}
                        </div>
                        : this.state.bingBuerShopStuts == 2 ?
                          <div className='main-up'>
                            <span className='main-up-title'>1688买家账号：</span>
                            <Tag type="warning">未绑定授权</Tag>
                            {/* <span className='mainColor' style={{ cursor: "pointer", marginLeft: "15px" }}>  <Button type="primary" style={{ width: "100px" }} onClick={() => this.authorizationDialog(true)}>点击登录</Button>  1688买家账号，订购并完成授权</span> */}
                           <span className='mainColor' style={{ cursor: "pointer", marginLeft: "15px" }}>  <Button type="primary" style={{ width: "100px" }} onClick={() => this.authPuhuo()}>立即授权</Button></span>
                          </div>
                          : <div className='loadmore loading' style={{marginLeft:"15px",fontSize:"14px"}}><Icon name='loading' style={{marginRight:"5px"}} />加载中...</div>
                    }
                  </div>
                  :null
                }
                {/* {
                  // systemConfig.isZk5() && 
                  (!this.state.from_action || this.state.from_action == "taote_auth_expire")?
                  <div className='sourceplatform-item'>
                    <div className='main-up sourceplatform-item-title'>淘特分销货源授权绑定情况</div>
                    {
                      this.state.taoteAuthInfo.status == 1 ?
                        <div>
                          <div className='main-up'>
                            <span className='main-up-title'>淘特买家账号：</span>
                            <span>{this.state.taoteAuthInfo.nickName}</span>
                            {
                              !this.state.unBindBuyerShopStatus && (systemConfig.isZk1() || systemConfig.isZk5()) ? 
                                <span className='unBindBuyerShop-text' 
                                onClick={()=>{ this.unBindBuyerShop({ buyerShopId:this.state.taoteAuthInfo.shopId,PlatformType:'TaoteZhuKe' })}}>解绑货源账号</span>:null
                            }
                            {
                              this.state.unBindBuyerShopStatus == '2' ? <span  className='unBindBuyerShop-doing-text'>账号解绑中...,请勿进行其他操作</span>:null
                            }
                            <span></span>
                          </div>
                          <div className='main-up'>
                            <span className='main-up-title'>淘特授权状态: </span>
                            {
                              this.state.from_action == "taote_auth_expire" || systemConfig.zhukeTaoteAuth === false?
                                <Tag type="danger">授权失效</Tag>:<Tag type="success">已授权</Tag>
                            }
                            {
                              !this.state.unBindBuyerShopStatus ?
                                <Button type="primary" size="small" style={{"marginLeft":"10px"}} onClick={() => this.reAuthTaote()}>重新授权</Button> : null
                            }
                            
                          </div>
                        </div>: 
                      this.state.taoteAuthInfo.status == 2? 
                        <div>
                          <div className='main-up'>
                            <span className='main-up-title'>淘特买家账号：</span>
                              <Tag type="warning">未绑定，请先完成淘特买家账号授权后再使用</Tag>
                              <span className='mainColor' style={{ cursor: "pointer", marginLeft: "15px" }}>  <Button type="primary" onClick={() => this.taoteGenerateQRCodeClick(true)}>立即免费授权</Button></span>
                          </div>
                          <div className='main-up'>
                              <span className='main-up-title'>淘特授权状态：</span>
                              <Tag type="warning">未授权</Tag>
                          </div>
                        </div>:
                      <div className='loadmore loading' style={{marginLeft:"15px",fontSize:"14px"}}><Icon name='loading' style={{marginRight:"5px"}} />加载中...</div>
                    }
                  </div>:null
                } */}
              </div>
            </div>
            {
              !this.state.from_action && false ? 
              <div className='mywrap'>
                <div className='mywrap-title'>我的店铺</div>
                {
                  /**添加店铺功能 */
                  systemConfig.isZk1() && (this.state.bingBuerShopStuts == 1 || this.state.taoteAuthInfo.status == 1)?
                  <div> 
                    <div style={{"paddingLeft":"930px","marginBottom":"8px"}}>
                      <span className='el-icon-plus' onClick={()=>{ this.addShop() }}> </span>
                      <span onClick={()=>{ this.addShop() }}> 添加店铺</span>
                    </div>
                  </div>:null
                }
                <div>
                  {
                    this.state.bindShopList.length > 0? 
                      <Table
                        style={{width: '1000px'}}
                        columns={this.state.shopTableColumn}
                        data={this.state.bindShopList}
                      />:null
                  }
                </div>
              </div>:null
            }
          </div>
        </main>

         
         {/* 弹窗1 */}
        <Dialog
          title="添加货源授权"
          size="tiny"
          visible={this.state.authorizationDialogVisible}
          onCancel={() => this.setState({ authorizationDialogVisible: false })}
          lockScroll={false}
          customClass="authorizationDialogWrap"
        >
          <Dialog.Body>
            <div className='authorizationDialog'>
              <Alert title="因跨平台无法获取到货源信息，请先订购1688【铺货代发】并完成授权。" type="warning" closable={false} />
              <div className='authorizationDialog-icons'>
                <Steps space={100} direction="vertical" active={2}>
                  <Steps.Step>
                  </Steps.Step>
                  <Steps.Step></Steps.Step>
                </Steps>
              </div>
              <div className='authorizationDialog-content'>
                <div className='authorizationDialog-steps'>
                  <span className='operateWrap-title'>第一步：请先点击下方“免费订购铺货代”按钮。</span>
                  <Button style={{ width: "275px" }} type="primary" onClick={() => this.newPayPuHuo()}>免费订购铺货代发</Button>
                </div>
                <div className='authorizationDialog-steps' style={{ top: '50px',position:'relative' }}>
                  <span className='operateWrap-title'>第二步：订购完成后，点击“我已订购，立即授权”按钮</span>
                  <Button style={{ width: "275px" }} type="primary" onClick={() => this.authPuhuo()}>我已订购，立即授权</Button>
                </div>
              </div>
            </div>
          </Dialog.Body>
        </Dialog>
        
        <Dialog
          size="tiny"
          visible={this.state.taoteAuthInfo.qrcodeShow}
          onCancel={() => { this.setFieldData(this.state.taoteAuthInfo,"qrcodeShow",false);this.clearTaoteQrInfo() }}
          lockScroll={false}
          closeOnClickModal={false}
          closeOnPressEscape={false}
          style={{width:"350px"}}
          customClass="authorizationDialogWrap"
          className="taoteDailog"
        >
          <Dialog.Body>
            <div className='qrcodewarp'>
              <div>
                <h4>使用手机版淘特APP扫码授权</h4>
              </div>
              <div>
                {
                  this.state.taoteAuthInfo.authUrl ?
                  <div style={{"marginLeft":"10px"}}> 
                    <QRCode
                        id="bill_qr_code_url"
                        value={this.state.taoteAuthInfo.authUrl} //value参数为生成二维码的链接 我这里是由后端返回
                        size={200} //二维码的宽高尺寸
                        fgColor="#000000"  //二维码的颜色
                    />
                  </div>: 
                  <div className={ this.state.taoteAuthInfo.refreshQRCode ?'refresQrCode active':'refresQrCode'}>
                    <i className={'iconfont icon-tongbu'} onClick={()=>{ this.taoteGenerateQRCode() }} style={{"fontSize":"50px"}}></i>
                  </div>
                }
                <div>授权二维码过期时间倒计时： { 
                  this.state.taoteAuthInfo.authTimeSpan == 0 ?
                  <span style={{"color":"red"}}>已过期</span>:
                  <span><span id='authTimespan'></span>秒</span>
                  
                }</div>
              </div>
            </div>
            <div className='hint'>
              提示：分销淘特商品需要使用淘特买家账号获取授权，请打开手机版本淘特APP，扫一扫此二维码，完成授权
            </div>
          </Dialog.Body>
        </Dialog>

        <Dialog
          size="tiny"
          visible={this.state.unBindBuyerShopDoingDialog}
          lockScroll={false}
          closeOnClickModal={false}
          closeOnPressEscape={false}
          style={{width:"350px",marginTop:"100px"}}
          title='解绑采购账号提示'
          onCancel={()=>{this.setState({unBindBuyerShopDoingDialog:false})}}
        >
          <Dialog.Body>
            <div style={{"color":"#3aadff"}}> 采购账号解绑中......</div>
            <div style={{"marginTop":"10px"}}>
              请勿关闭页面中断操作，解绑采购账号需要—定时间处理，请耐心等待!请勿进行其他操作
              {/* 进度显示100%后，方可继续其他操作 */}
            </div>
            <div style={{"display":"flex","justifyContent":"end","marginTop":"10px"}}>
              <Button type='primary' onClick={()=>{this.setState({unBindBuyerShopDoingDialog:false})}}>后台处理</Button>
            </div>
          </Dialog.Body>
        </Dialog>
          
          {/* 选择平台弹窗*/}
          <ShowModal titleName={"选择平台"} width={"680px"} showModal={this.state.isShowChoosePlatform} sureDailog={this.sureChoosePlatform} cancelDailog={() => this.cancelModul("isShowChoosePlatform")} >
              <DialogShowPlatforms changeShops={this.changeShops} selectPlatform={this.state.selectPlatform} />
          </ShowModal>
         {/* 添加店铺步骤弹窗*/}
         <ShowModal titleName={"添加" + this.state.selectPlatformName + "店铺"} width={"680px"} showModal={this.state.isShowAddShop} hideBtn={true}>
            <div>
                <DialogAddShopSteps sureAuthShop={this.sureAuthShop} selectPlatformName={this.state.selectPlatformName} selectPlatform={this.state.selectPlatform} showContact={()=>{ }} />
                <div className="showModalWrap-box-commonfooter">
                    <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeAddShopModal()}>关闭</span>
                </div>
            </div>
        </ShowModal>

        <ShowModal width={"500px"} showModal={this.state.isShowAuthShop} sureDailog={this.successAuthShop} sureBtnName={"完成授权"} cancelDailog={() => this.cancelModul("isShowAuthShop")}>
            <div style={{ padding: "20px", fontSize: "16px" }}>你是否已经完成授权？</div>
        </ShowModal>

        <ShowModal 
            width={'510px'} 
            showModal={this.state.isShowUnBind} 
            sureDailog={()=>this.startUnBing()}   
            cancelDailog={() => this.cancelModul("isShowUnBind")}>
            <div className="showModalWrap-box-commonContent"  style={{padding:"10px",fontSize:"16px","marginBottom":"30px"}}>
                <div className="showModalWrap-commonContent-item" >
                    <i className="iconfont icon-wenhao icofontStatus"></i>
                    {/* <span>确认是否移除店铺【{this.state.unBingShopName}】？</span> */}
                    
                    <div class="inlineBlock">
                        <p>确认是否移除店铺【{this.state.unBingShopName}】？</p>
                        <p>解绑后工具中该店铺的所有数据将会被清除!</p>
                    </div>
                </div>
            </div>
        </ShowModal>
        <ShowModal 
            width={'500px'} 
            titleName={'续订/升级1688接口'}
            hideBtn={true} showLeftTopBtn={true} 
            showModal={this.state.upgradeDailog} 
            cancelDailog={() => this.cancelModul("upgradeDailog")}>
            <Tag type='danger' style={{height:'auto',lineHeight:'inherit',width:'470px',padding:'10px',textAlign:'center'}}>订购后请完成授权，用于获取最新1688授权信息！</Tag>
            <ul className='newUserGuideStepsWrap'>
              <li className='newUserGuideStepsWrap-item'>
                  <div className='newUserGuideStepsWrap-item-left'>
                      <span>1</span>
                  </div>
                  <div className='newUserGuideStepsWrap-item-mid' style={{justifyContent:'center'}}>
                      <div className='newUserGuideStepsWrap-item-mid-title'>
                          <span>请先订购1688应用</span>
                          <span></span>
                      </div>
                      <div className='newUserGuideStepsWrap-item-mid-content'></div>
                  </div>
                  <div className='newUserGuideStepsWrap-item-right'>
                      <span onClick={() => { this.xufeiPuHuo() }}>立即订购</span>
                  </div>
              </li>
              <li className='newUserGuideStepsWrap-item'>
                  <div className='newUserGuideStepsWrap-item-left'>
                      <span>2</span>
                  </div>
                  <div className='newUserGuideStepsWrap-item-mid' style={{justifyContent:'center'}}>
                      <div className='newUserGuideStepsWrap-item-mid-title'>
                          <span>点击按钮进行授权</span>
                          <span></span>
                      </div>
                      <div className='newUserGuideStepsWrap-item-mid-content'></div>
                  </div>
                  <div className='newUserGuideStepsWrap-item-right'>
                      <span onClick={() => this.authPuhuo()}>立即授权</span>
                  </div>
              </li>
              <li className='newUserGuideStepsWrap-item-help'>
                  <div>
                    <span>遇到问题？请 </span>
                    <span className='defColor hover' onClick={()=>{ this.showContact() }}>联系客服</span>
                  </div>
              </li>
          </ul>
        </ShowModal>
        <MyLoading isLoading={this.state.loading} isStopOperate={true} fullCenter={true} title="处理中..." />
    
        <NewUserGuide onRef={ ref=>{ this.NewUserGuide = ref } }></NewUserGuide>
      </div>

    )
  }
}

export default distributionLog;


// WEBPACK FOOTER //
// ./src/pages/myAuth/myAuth.jsx